/**
 * Normalizes a community slug to ensure it's a valid string
 * Handles cases where slug might be an object, null, undefined, or invalid string
 * 
 * @param {string|object|null|undefined} slug - The community slug to normalize
 * @returns {string} Normalized slug string or empty string if invalid
 */
export function normalizeCommunitySlug(slug) {
  if (!slug) {
    return '';
  }

  // Handle object slugs (shouldn't happen but defensive programming)
  if (typeof slug === 'object' && slug !== null) {
    console.warn('normalizeCommunitySlug - detected object instead of string for slug', slug);
    return slug.slug || slug.id || '';
  }

  // Ensure it's a string
  const normalized = String(slug);

  // Check for invalid string values
  if (
    !normalized ||
    normalized === 'undefined' ||
    normalized === 'null' ||
    normalized === 'error'
  ) {
    return '';
  }

  return normalized;
}

/**
 * Validates if a community slug is valid
 * 
 * @param {string} slug - The community slug to validate
 * @returns {boolean} True if slug is valid, false otherwise
 */
export function isValidCommunitySlug(slug) {
  const normalized = normalizeCommunitySlug(slug);
  return normalized.length > 0;
}
